<div>
    <app-messages></app-messages>
    <router-outlet></router-outlet>
</div>
